"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIN_JOURNAL_ENTRY_RESPONSE_EXAMPLE = void 0;
exports.FIN_JOURNAL_ENTRY_RESPONSE_EXAMPLE = {
    id: '11111111-1111-4111-8111-111111111111',
    entryNumber: 'JV-2026-000001',
    entryDate: '2026-07-20',
    entryType: 'MANUAL',
    status: 'POSTED',
    narration: 'Office rent for July',
    totalDebit: 5000000,
    totalCredit: 5000000,
    branchId: null,
    hospitalId: null,
    accountingPeriodId: '22222222-2222-4222-8222-222222222222',
    sourceEventLogId: null,
    reversalOfEntryId: null,
    approvedBy: null,
    approvedAt: null,
    rejectedBy: null,
    rejectedAt: null,
    rejectionReason: null,
    postedBy: '33333333-3333-4333-8333-333333333333',
    postedAt: '2026-07-20T10:00:00.000Z',
    externalReference: null,
    projectTag: null,
    createdAt: '2026-07-20T09:55:00.000Z',
};
//# sourceMappingURL=financial-journal.response.js.map